// extracted by css-extract-rspack-plugin
export default {"root":"VM7X2J","line":"D_Q8CM","text":"BSMbFr"};